<template>
  <header class="site-header">
    <router-link class="brand" to="/pod" aria-label="SRFulfill home">
      <!-- <span class="brand-mark">SR</span>
      <span>
        <strong>Fulfill</strong>
        <small>FASTER - SIMPLER - RELIABLE</small>
      </span> -->
      <img src="@/assets/img/logo.jpg" class="team-img" style="height:50px;width:150px;"/>
    </router-link>

    <nav class="nav-links" aria-label="Primary navigation">
      <router-link to="/index">POD</router-link>
      <router-link to="/about_us">About Us</router-link>
      <router-link to="/contact_us">Contact Us Now</router-link>
      <router-link to="/blogs">Blog</router-link>
    </nav>

    <router-link class="quote-button" to="/contact_us">Get a Free Quote <span>&gt;</span></router-link>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader'
};
</script>
